<template>
  <div id="top-people">
    <div class="">
      <slot name="chosen-card"></slot>
      <v-layout row wrap align-center justify-center fill-height mx-5>
        <v-flex xs4 lg2 order-lg2 v-for="(person,key) in people" :key="key"
                @click="updateChosen(person)">
          <v-card class="ma-2 v-card--hover">
            <v-img :src="$helper.imgServerUrl() + person.img" aspect-ratio="1" :alt="'Profile picture from '+ person.firstName + ' ' + person.lastName"></v-img>
            <v-card-title>{{person.firstName}} {{person.lastName}}</v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
  export default {
    name: "people",
    props: {
      people: {
        type: Array,
        required: true
      }
    },
    methods: {
      updateChosen(person) {
        this.$vuetify.goTo('#top-people', {offset: -100, duration: 300, easing: "easeOutCubic"})
        this.$emit('updateChosen', person)
      }
    },
  }
</script>

